// Plugins
import i18n from '@/plugins/i18n'

export default function(user) {
    let requestTypes = [];

    // Bed Hold Request
    requestTypes.push({
        value: "bed-hold-request",
        text: i18n.t("bed_hold_request"),
        permission: "studentprogram_missingdocumentexcelexport",
    });

    // Request Type
    requestTypes.push({
        value: "request-type",
        text: i18n.t("request_type"),
        permission: "student_studentnotesreport",
    });

    // Room Change Request
    requestTypes.push({
        value: "room-change-request",
        text: i18n.t("room_change_request"),
        permission: "student_studentnotesreport",
    });

    // Work Order Request
    requestTypes.push({
        value: "work-order-request",
        text: i18n.t("work_order_request"),
        permission: "studentreport_registrationnumbersbyfaculty",
    });

    // Initial Complaint
    requestTypes.push({
        value: "initial-complaint",
        text: i18n.t("initial_complaint"),
        permission: "studentreport_registrationnumbersbyfaculty",
    });

    return requestTypes;
}


